import { styled, useTheme } from '@mui/material';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { DealTimeLog } from '../../../types';
import { Typography } from '../../../components/Typography/Typography';

const CellWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const columnHelper = createColumnHelper<DealTimeLog>();

export const useOpChargeSummarySubTableColumns = () => {
  const { colors } = useTheme();

  const columns = useMemo(() => {
    return [
      columnHelper.accessor('user', {
        cell: (info) => {
          const userName = info.row.original.user.name;
          return (
            <CellWrapper>
              <Typography
                variant='h4'
                color={colors.text.main}
                style={{
                  paddingLeft: '62px',
                }}
              >
                {userName}
              </Typography>
            </CellWrapper>
          );
        },
        meta: {
          width: '400px',
          maxWidth: '400px',
          minWidth: '400px',
          tdStyles: { paddingLeft: '16px', borderRight: `none` },
          thStyles: { borderRight: `none`, paddingLeft: '16px' },
        },
      }),
      columnHelper.accessor(`avg`, {
        cell: (info) => (
          <CellWrapper>
            <Typography variant='body' color={colors.text.caption} style={{ textAlign: 'right' }}>
              {info.getValue() || info.getValue() === 0 ? `${info.getValue().toFixed(2)}%` : '-'}
            </Typography>
          </CellWrapper>
        ),
        meta: {
          tdStyles: { paddingLeft: '16px', borderRight: `none`, borderLeft: 'none' },
          thStyles: { borderRight: `none`, paddingLeft: '16px', borderLeft: 'none' },
        },
      }),
    ];
  }, [colors]);

  return columns;
};
